(function () {
  function initQuickBuy(section) {
    if (!section || section.dataset.quickBuyReady === 'true') return;

    var form = section.querySelector('form');
    var trigger = document.querySelector(section.dataset.triggerSelector);
    var variantSelect = section.querySelector('[data-quick-buy-variant]');
    var price = section.querySelector('[data-quick-buy-price]');
    var priceLabel = section.querySelector('[data-quick-buy-price-label]');
    var compareWrap = section.querySelector('[data-quick-buy-compare-wrap]');
    var compare = section.querySelector('[data-quick-buy-compare]');
    var availability = section.querySelector('[data-quick-buy-availability]');
    var availabilityLabel = section.querySelector('[data-quick-buy-availability-label]');
    var addButton = section.querySelector('[data-quick-buy-submit]');
    var addLabel = section.querySelector('[data-quick-buy-add-label]');
    var buyButton = section.querySelector('[data-quick-buy-now]');
    var mainVariantSelect = trigger && trigger.querySelector('[data-variant-select]');
    var documentElement = document.documentElement;
    var pageBottomPadding = '';
    var resizeObserver;
    var visibilityObserver;

    if (!form || !variantSelect || !addButton || !buyButton) return;

    function updateVariant() {
      var option = variantSelect.options[variantSelect.selectedIndex];
      if (!option) return;

      var isAvailable = option.dataset.available === 'true';
      var comparePrice = option.dataset.compare;

      if (price) price.textContent = option.dataset.price;
      if (priceLabel) priceLabel.textContent = comparePrice ? 'Sale price' : 'Regular price';
      if (compare) compare.textContent = comparePrice;
      if (compareWrap) compareWrap.hidden = !comparePrice;

      addButton.disabled = !isAvailable;
      buyButton.disabled = !isAvailable;
      if (addLabel) {
        addLabel.textContent = isAvailable ? addButton.dataset.availableLabel : addButton.dataset.soldOutLabel;
      }
      if (availability) availability.classList.toggle('is-sold-out', !isAvailable);
      if (availabilityLabel) {
        availabilityLabel.textContent = isAvailable ? variantSelect.dataset.availableLabel : addButton.dataset.soldOutLabel;
      }

    }

    function updateFixedControlSpacing() {
      document.body.style.paddingBottom = section.offsetHeight + 24 + 'px';
      documentElement.style.setProperty('--product-quick-buy-inbox-offset', section.offsetHeight + 32 + 'px');
    }

    function setVisibility(isVisible) {
      section.classList.toggle('is-visible', isVisible);
      section.setAttribute('aria-hidden', String(!isVisible));
      if (isVisible) {
        documentElement.dataset.productQuickBuyVisible = 'true';
        updateFixedControlSpacing();
      } else {
        delete documentElement.dataset.productQuickBuyVisible;
        documentElement.style.removeProperty('--product-quick-buy-inbox-offset');
        document.body.style.paddingBottom = pageBottomPadding;
      }
    }

    function syncFromMainForm() {
      if (!mainVariantSelect || !mainVariantSelect.value) return;
      variantSelect.value = mainVariantSelect.value;
      updateVariant();
    }

    pageBottomPadding = document.body.style.paddingBottom;

    if (trigger && 'IntersectionObserver' in window) {
      visibilityObserver = new IntersectionObserver(function (entries) {
        setVisibility(!entries[0].isIntersecting);
      });
      visibilityObserver.observe(trigger);
    } else {
      setVisibility(true);
    }

    variantSelect.addEventListener('change', updateVariant);
    if (mainVariantSelect) mainVariantSelect.addEventListener('change', syncFromMainForm);
    if ('ResizeObserver' in window) {
      resizeObserver = new ResizeObserver(function () {
        if (section.classList.contains('is-visible')) updateFixedControlSpacing();
      });
      resizeObserver.observe(section);
    }
    syncFromMainForm();
    if (!mainVariantSelect) updateVariant();
    section.quickBuyCleanup = function () {
      if (visibilityObserver) visibilityObserver.disconnect();
      if (resizeObserver) resizeObserver.disconnect();
      variantSelect.removeEventListener('change', updateVariant);
      if (mainVariantSelect) mainVariantSelect.removeEventListener('change', syncFromMainForm);
      if (section.classList.contains('is-visible')) setVisibility(false);
      delete section.quickBuyCleanup;
      delete section.dataset.quickBuyReady;
    };
    section.dataset.quickBuyReady = 'true';
  }

  function initAll() {
    document.querySelectorAll('[data-product-quick-buy]').forEach(initQuickBuy);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.matches('[data-product-quick-buy]')
      ? event.target
      : event.target.querySelector('[data-product-quick-buy]');
    initQuickBuy(section);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target.matches('[data-product-quick-buy]')
      ? event.target
      : event.target.querySelector('[data-product-quick-buy]');
    if (section && section.quickBuyCleanup) section.quickBuyCleanup();
  });
})();
